import { IState } from '@/store/types';

export const getProductByName = (state: IState, name: string) => {
  return state.org?.products?.find((product) => product.name === name);
};
